






































































































import _ from 'lodash';
import numeral from 'numeral';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {Http} from '@/decorators';
import {httpService, i18nService} from '@/services';
import {AxiosResponse} from 'axios';

import ReportLegend from '@/modules/neodash/components/report-legend/report-legend.vue';
import {CONFIG} from '@/config';
import {REPORT_GET_REPORTS} from '@/modules/neodash/store/modules/report/types';
import {PRINT_GET_PRINT_MODE} from '@/store/modules/print/types';
import * as moment from 'moment';

@Component({
  components: {
    ReportLegend
  }
})
export default class RegistrationInSegment extends Vue {

  props: {
    dataQuery: {
      type: Object,
      required: true
    }
  };

  numeral = numeral;

  @Prop({required: true})
  dataQuery: any;

  @Getter(REPORT_GET_REPORTS) reports: any;
  @Getter(PRINT_GET_PRINT_MODE) printMode: any;

  public state: any = {
    dataSource: [],
    requestData: {},
    client: ''
  };

  public yearsHead: number[];
  public monthInit: string;
  public monthLast: string;
  public tipoReport: string;
  public tituloLocalidade: string;
  public dateAtualDescription: string = `${i18nService.i18n('Common.ActualDate')}: ` + moment(new Date()).format('DD/MM/YYYY');

  @Watch('dataQuery')
  public requestData() {
    this.state.requestData = {
      TypeLocality: this.dataQuery.resolutionLevel.value[0],
      YearLast: this.dataQuery.ano.value,
      MonthInit: this.dataQuery.mes_inicial.value,
      MonthLast: this.dataQuery.mes_final.value,
      GeoCodigos: this.dataQuery.localidades.value,
      VirtualAreaType: this.dataQuery.virtualAreaType ? this.dataQuery.virtualAreaType.value[0] : 0,
      TypeLicensePlate: this.dataQuery.tipo_emplacamento.value
    };

    this.monthInit = this.dataQuery.mes_inicial.text.substring(0, 3);
    this.monthLast = this.dataQuery.mes_final.text.substring(0, 3);
    this.tipoReport = this.dataQuery.tipo_emplacamento.value === 1 ? 'SALES' : this.dataQuery.tipo_emplacamento.value === 2 ? 'DIRECT SALES' : 'TOTAL';
    this.yearsHead = _.range((this.state.requestData.YearLast) - 3, this.state.requestData.YearLast + 1);
    this.tituloLocalidade = this.dataQuery.localidades.text.length === 1 ? this.dataQuery.localidades.text[0].toUpperCase() + ' -' : '';

    httpService
        .http
        .post(`${CONFIG.URL.NEODASH_API}/api/gigdashfilters/getDSRegistrationInSegment`, this.state.requestData)
        .then((res: AxiosResponse) => {
          if (res.data) {
            this.yearsHead = _.uniq(res.data.registration.map(x => x.ano));
          }

          this.state.client = res.data ? res.data.nameClient : '';
          this.state.dataSource = res.data ?
              _(res.data.registration)
                  .groupBy((d: any) => d.nome_segmento)
                  .map((d: any) => {
                    this.yearsHead
                        .filter((f: any) => !d.some((vl: any) => f === vl.ano) && f.nome_segmento != '')
                        .forEach((value) => {
                          d.push({
                            nome_segmento: d[0].nome_segmento,
                            ano: value,
                            emplac_bnd: 0,
                            emplac_ind: 0,
                            mkt_share: 0
                          });
                        });

                    return _.orderBy(d, 'ano');
                  })
                  .orderBy((d: any) => d[0].ordem).value() : [];

          //Ajuste para solucionar erro de banco aonde a ordem do total está errada.
          var total = this.state.dataSource.filter(function (f) {
            return f[0].nome_segmento == 'TOTAL'
          });
          this.state.dataSource = this.state.dataSource.filter(function (f) {
            return f[0].nome_segmento != 'TOTAL'
          })
          this.state.dataSource = this.state.dataSource.concat(total);

          // this.state.dataSource.push(this.yearsHead.map((a: any)=> {return {
          //     nome_segmento: 'TOTAL',
          //     ano: a,
          //     emplac_bnd: _.sumBy(res.data.registration.filter((f: any)=> {return f.ano == a}), 'emplac_bnd'),
          //     emplac_ind: _.sumBy(res.data.registration.filter((f: any)=> {return f.ano == a}), 'emplac_ind'),
          //     mkt_share: _.sumBy(res.data.registration.filter((f: any)=> {return f.ano == a}), 'emplac_bnd') / _.sumBy(res.data.registration.filter((f: any)=> {return f.ano == a}), 'emplac_ind')
          //     }}));
          //
        });
  }

  public created() {
    this.requestData();
  }
}
